import React from "react";
import mock01 from '../assets/images/mock01.png';
import mock02 from '../assets/images/mock02.png';
import mock03 from '../assets/images/mock03.png';
import mock04 from '../assets/images/mock04.png';
import mock05 from '../assets/images/mock05.png';
import mock06 from '../assets/images/mock06.png';
import mock07 from '../assets/images/mock07.png';
import mock08 from '../assets/images/mock08.png';
import mock09 from '../assets/images/mock09.png';
import mock10 from '../assets/images/mock10.png';
import mock11 from '../assets/images/mock11.png';
import mock12 from '../assets/images/mock12.png';
import mock13 from '../assets/images/mock13.png';
import mock14 from '../assets/images/mock14.png';
import mock15 from '../assets/images/mock15.png';

import '../assets/styles/Project.scss';

function Project() {
    return(
    <div className="projects-container" id="projects">
        <h1>Personal Projects</h1>
        <div className="projects-grid">
            <div className="project">
                <a href="https://play.google.com/store/apps/details?id=si.cnj.tarifnik&hl=en" target="_blank" rel="noreferrer"><img src={mock12} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://play.google.com/store/apps/details?id=si.cnj.tarifnik&hl=en" target="_blank" rel="noreferrer"><h2>Tarifnik</h2></a>
                <p>The Tarifnik app enables users to monitor current electricity tariff blocks, calculate penalties, and assess network fees. 
                </p>
            </div>
            <div className="project">
                <a href="https://play.google.com/store/apps/details?id=com.otasync.bookers&hl=en" target="_blank" rel="noreferrer"><img src={mock13} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://play.google.com/store/apps/details?id=com.otasync.bookers&hl=en" target="_blank" rel="noreferrer"><h2>OTA Sync Mobile Hotel PMS Application</h2></a>
                <p>Mobile PMS app for seamless hotel management with real-time booking, guest check-in, and OTA integration.</p>
            </div>
            <div className="project">
                <a href="" target="_blank" rel="noreferrer"><img src={mock11} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="" target="_blank" rel="noreferrer"><h2>Bravo AI App</h2></a>
                <p>Developed Bravo AI, an AI-driven educational app using React Native, Expo, and NLP for interactive learning, quizzes, and feedback.</p>
            </div>
            <div className="project">
                <a href="https://baitium.com/" target="_blank" rel="noreferrer"><img src={mock14} className="zoom" alt="thumbnail" width="100%" height="70%"/></a>
                <a href="https://baitium.com/" target="_blank" rel="noreferrer"><h2>Baitium e-commerce</h2></a>
                <p>Developed Baitium, a modern e-commerce platform for performance fishing gear, emphasizing seamless UX, intuitive UI, and scalability.</p>
            </div>
            <div className="project">
                <a href="https://v0.dev/chat/bluesky-directory-site-rCUnrloO0Q3?b=b_Kp4vlzBa5th" target="_blank" rel="noreferrer"><img src={mock15} className="zoom" alt="thumbnail" width="100%" height="70%"/></a>
                <a href="https://v0.dev/chat/bluesky-directory-site-rCUnrloO0Q3?b=b_Kp4vlzBa5th" target="_blank" rel="noreferrer"><h2>Bluesky Directory</h2></a>
                <p>Bluesky Directory is curated platform showcasing tools and applications for the Bluesky social media ecosystem.</p>
            </div>
        </div>
    </div>
    );
}

export default Project;